import React from "react";
import Image from "../atoms/Image.jsx";
import Text from "../atoms/Text.jsx";
import styles from "./AboutMeSection.module.css";

/**
 * ロゴ＋自己紹介セクション
 * @param {object} props
 * @param {string} props.logoSrc - ロゴ画像URL
 * @param {string} props.logoAlt - ロゴ画像alt
 * @param {Array<string>} props.aboutTexts - 自己紹介テキスト配列
 * @param {string} [props.className] - 追加クラス
 */
const AboutMeSection = ({ logoSrc, logoAlt, aboutTexts, className = "" }) => (
  <section className={`${styles.aboutSection} ${className}`.trim()} id="logo">
    <div className={styles.logoContainer}>
      <Image src={logoSrc} alt={logoAlt} className={styles.logoImage} />
    </div>
    <div className={styles.textContainer}>
      <Text as="h3" className={styles.sectionTitle}>ABOUT ME</Text>
      {aboutTexts.map((text, i) => (
        <Text as="p" className={styles.sectionText} key={i}>{text}</Text>
      ))}
    </div>
  </section>
);

export default AboutMeSection; 